// extracted by mini-css-extract-plugin
var _1 = "breadcrumbs__SxF_7";
export { _1 as "breadcrumbs" }
